/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cool_Bold_Hawk_DropInputs */

const en_cool_bold_hawk_drop = /** @type {(inputs: Cool_Bold_Hawk_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete selected`)
};

const de_cool_bold_hawk_drop = /** @type {(inputs: Cool_Bold_Hawk_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte löschen`)
};

/**
* | output |
* | --- |
* | "Delete selected" |
*
* @param {Cool_Bold_Hawk_DropInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cool_bold_hawk_drop = /** @type {((inputs?: Cool_Bold_Hawk_DropInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cool_Bold_Hawk_DropInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cool_bold_hawk_drop(inputs)
	return de_cool_bold_hawk_drop(inputs)
});